export default __webpack_public_path__ + "static/pipeline-bg-b418a4ede7cbcab30946857f5cbdb1a4.png";